<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                MarketPlace Information
                            </h4>
                        </div>
                        <div class="row">
                            
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category:"
                                    label-for="category">
                                    <b-form-input id="category_id" v-model="category.title" disabled></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Model:"
                                    label-for="brand_models">
                                    <b-form-input id="brand_models" placeholder="Select brand model" v-model="brand_models.title" disabled></b-form-input>
                                </b-form-group>
                            </div>
    
    
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:"
                                    label-for="brands">
                                    <b-form-input id="brand_id" v-model="selectedBrand.name" disabled></b-form-input>
                                </b-form-group>
                            </div>


                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Year:" label-for="year">
                                    <b-form-input id="year" placeholder="Enter year"
                                        v-model="year" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration In:" label-for="registration_in">
                                    <b-form-input id="registration_in" placeholder="Enter registyration  in"
                                        v-model="registration_in" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration Number:" label-for="registration_number">
                                    <b-form-input id="registration_number" placeholder="Enter registration  number"
                                        v-model="registration_number" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Number:" label-for="engine_number">
                                    <b-form-input id="engine_number" placeholder="Enter engine nnumber"
                                        v-model="engine_number" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Color:" label-for="color">
                                    <b-form-input id="color" placeholder="Enter color"
                                        v-model="color" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="City:" label-for="city">
                                    <b-form-input id="city" placeholder="Enter city"
                                        v-model="city" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Area:" label-for="area">
                                    <b-form-input id="area" placeholder="Enter area"
                                        v-model="area" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Country:" label-for="country">
                                    <b-form-input id="country" placeholder="Enter country"
                                        v-model="country" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Mileage:" label-for="mileage">
                                    <b-form-input id="mileage" placeholder="Enter mileage"
                                        v-model="mileage" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                    <b-form-group id="input-group-2" label="Currency:" label-for="currency">
                                     <b-form-input id="currency" placeholder="Select a currency" v-model="currency" disabled>    
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Price:" label-for="price">
                                    <b-form-input id="price" placeholder="Enter price"
                                        v-model="price" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Kilometer Second Driven:" label-for="KMs_driven">
                                    <b-form-input id="KMs_driven" placeholder="Enter kilometer second"
                                        v-model="KMs_driven" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Fuel Type:" label-for="fuel_type">
                                    <b-form-input id="fuel_type" placeholder="Enter fuel type"
                                        v-model="fuel_type" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Transmission Type:" label-for="transmission_type">
                                    <b-form-input id="transmission_type" placeholder="Enter transmission type"
                                        v-model="transmission_type" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Capacity:" label-for="engine_capacity">
                                    <b-form-input id="engine_capacity" placeholder="Enter engine capacity"
                                        v-model="engine_capacity" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" type="text" id="description" placeholder="Enter description"
                                        v-model="description" disabled>
                                    </textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Features:" label-for="features">
                                    <b-form-input id="features" placeholder="Enter features"
                                        v-model="features" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Assemble:" label-for="assembly">
                                    <b-form-input id="assembly" placeholder="Enter assembly"
                                        v-model="assembly" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Satus:" label-for="status">
                                    <b-form-input id="status" placeholder="Enter status"
                                        v-model="status" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                                      <!-- Document Upload Field -->
                    
                                
                            <!-- images   code  here  -->
                            <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
                                <div class="lightbox-content">
                                    <img :src="selectedImage" alt="Vehicle Image" class="lightbox-image" />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Documents:" label-for="images">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <b-button v-if="editedUser.documents && editedUser.documents.length > 1" size="sm" :variant="docReorderMode ? 'warning' : 'info'" @click="toggleDocReorder">
                                            {{ docReorderMode ? 'Cancel' : 'Reorder' }}
                                        </b-button>
                                        <b-button v-if="docReorderMode" size="sm" variant="success" @click="saveDocOrder" :disabled="savingDocOrder">
                                            <span v-if="!savingDocOrder">Save Order</span>
                                            <b-spinner v-else small></b-spinner>
                                        </b-button>
                                    </div>
                                    <draggable v-if="docReorderMode" v-model="docList" handle=".drag-handle" tag="div" class="d-flex flex-wrap">
                                        <div v-for="(doc, index) in docList" :key="doc.id" class="reorder-image-item mr-2 mb-2 text-center">
                                            <span class="drag-handle" style="cursor: grab; font-size: 16px; display: block;">&#x2630;</span>
                                            <img :src="'https://wossdb.wossautoid.com/' + doc.documents" alt="Document" width="100" height="100" class="border rounded" />
                                            <div class="small text-muted">{{ index + 1 }}</div>
                                        </div>
                                    </draggable>
                                    <div v-else-if="documentPreviews.length" style="margin-left: 3px; margin-bottom: 15px">
                                        <img
                                            v-for="(doc, index) in documentPreviews"
                                            :key="index"
                                            :src="doc"
                                            alt="Vehicle Document"
                                            width="100"
                                            height="100"
                                            style="margin-right: 10px; cursor: pointer;"
                                            @click="openLightbox(doc)"
                                        />
                                    </div>
                                    <div v-else>
                                    <span>No document available</span>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
              <code class="hljs html">
                {{ codeText }}
              </code>
            </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            commission: "",
            selectedCarType: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,

            year: "",
            brand_models: '',
            // brand_id: '',
            // brands:'',
            brands: [],
            selectedBrand: {},
            registration_in:"",
            registration_number: '',
            engine_number: '',
            color: '',
            city: '',
            area: '',
            country: '',
            mileage: '',
            currency: '',
            price: '',
            KMs_driven: '',
            fuel_type: '',
            transmission_type: '',
            engine_capacity: '',
            description: '',
            features: '',
            assembly: '',
            status: '',
            category:"",
            user_id:"",
            documents: [],
            docReorderMode: false,
            docList: [],
            savingDocOrder: false,
            documentFiles: [],
            documentPreviews: [],
            image: [], 
            lightboxVisible: false,
            selectedImage: '',
            successMessage: '',
            
            };
            },
            components: {
                BRow,
                BCol,
                BCard,
                BButton,
                BForm,
                BFormGroup,
                BFormCheckboxGroup,
                BFormCheckbox,
                BFormSelect,
                BFormInput,
                BToast,
                BSpinner,
                draggable,
            },
            mounted() {
             
                    axios.get('brandModel')
                        .then(response => {
    
                            this.brandModels = response.data.data.map(model => ({
                                value: model.id,  
                                text: model.title 
                            }));
                        })
                        .catch(error => {
                        });

                        axios.get('CategoryList')
                        .then(response => {
    
                            this.categories = response.data.data.map(category => ({
                                value: model.id,  
                                text: model.title 
                            }));
                        })
                        .catch(error => {
                        });

                        axios.get('brandList')
                    .then(response => {
                        this.brands = response.data.data.map(brand => ({
                            value: brand.id,  
                            text: brand.name  
                        }));

                    })
                    .catch(error => {
                    });
            }, 
    created() {
        const userId = this.$route.params.id;
         this.type = localStorage.getItem("type");
                const endpoint = this.type === "manager" ? "marketPlaceShowManager" : "marketPlaceShow";
        axios.get(`${endpoint}/${userId}`)
            .then((response) => {
                this.editedUser = response.data.data;
                this.year = this.editedUser.year;
                this.brand_models = this.editedUser.brand_models;
                this.brands = this.editedUser.brands;
                this.selectedBrand = this.editedUser.brands;
                this.category = this.editedUser.category;
                this.registration_number = this.editedUser.registration_number;
                this.engine_number = this.editedUser.engine_number;
                this.registration_in = this.editedUser.registration_in;
                this.color = this.editedUser.color;
                this.city = this.editedUser.city;
                this.area = this.editedUser.area;
                this.country = this.editedUser.country;
                this.mileage = this.editedUser.mileage;
                this.currency = this.editedUser.currency;
                this.price = this.editedUser.price;
                this.KMs_driven = this.editedUser.KMs_driven;
                this.fuel_type = this.editedUser.fuel_type;
                this.transmission_type = this.editedUser.transmission_type;
                this.engine_capacity = this.editedUser.engine_capacity;
                this.description = this.editedUser.description;
                this.features = this.editedUser.features;
                this.assembly = this.editedUser.assembly;
                this.status = this.editedUser.status;
                this.image = this.editedUser.image;
                this.user_id = this.editedUser.user_id;
                // this.documents = this.editedUser.documents;
                // this.image = this.editedUser.image;
                this.documentPreviews = this.editedUser.documents.map(
                    doc => `https://wossdb.wossautoid.com/${doc.documents}`
                );
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    },
    methods: {
        openLightbox(imgUrl) {
            this.selectedImage = imgUrl; // Use the passed image URL directly
            this.lightboxVisible = true;
        },
        closeLightbox() {
            this.lightboxVisible = false;
        },
    
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
        },
       
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
        toggleDocReorder() {
            if (this.docReorderMode) {
                this.docReorderMode = false;
                this.docList = [];
                return;
            }
            this.docList = [...this.editedUser.documents];
            this.docReorderMode = true;
        },
        async saveDocOrder() {
            this.savingDocOrder = true;
            try {
                const ids = this.docList.map(doc => doc.id);
                await axios.post("documentsReorder", { ids });
                this.editedUser.documents = [...this.docList];
                this.documentPreviews = this.docList.map(
                    doc => `https://wossdb.wossautoid.com/${doc.documents}`
                );
                this.docReorderMode = false;
                this.docList = [];
                this.$bvToast.toast("Document order saved successfully!", {
                    title: "Success", variant: "primary", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 3000,
                });
            } catch (error) {
                console.error("Error saving document order:", error);
                this.$bvToast.toast("Error saving document order!", {
                    title: "Error", variant: "danger", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 5000,
                });
            } finally {
                this.savingDocOrder = false;
            }
        },
    },
};
</script>

  
<style scoped>
.reorder-image-item {
    position: relative;
    padding: 4px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #fff;
}
.drag-handle:hover {
    color: #2f855a;
}
.lightbox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.lightbox-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
}

.lightbox-image {
    max-width: 100%;
    max-height: 80vh;
}
</style>